import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography,Box } from '@mui/material';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, request, toast } from '../../../../../utils';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const LocationWiseStockSummary = () => {
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const { pathname } = useLocation();
  const [openPrint, setOpenPrint] = useState(false);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0],
    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset } = methods;

  return (
    <>
      <Paper sx={{
        p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
        width: '100%',
        height: 'auto'
      }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
              Location Wise Stock Summary
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
            
                  onClick={() =>
                    window.open(
                      `/print${pathname}`,
                      '_blank'
                    )
                  }
                >
                  View Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
